const STATE_FILING_VALUE = '$99/state value'

export const UNLIMITED_STATE_FILINGS_COPY = {
  planDetail: `Unlimited state tax filings (${STATE_FILING_VALUE})`,
  promo: `Free unlimited state filings included (${STATE_FILING_VALUE})`,
} as const
